export default __webpack_public_path__ + "static/media/RealCase-sc.57abdd36.jpg";